module.exports = __webpack_public_path__ + "static/media/sidebar-student-success-mobile.e7e4bdfa.jpg";